const productController = UD_VUE.createApp({
  data() {
    return {
      options: {},
      quantity: 1,
    };
  },

  // beforeCreate() {
  //   this.product.title.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
  //   // sanitizeHtml(val) {
  //   //   console.log(val)
  //   //   return val.replace("<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi", "");
  //   // }
  // },

  computed: {
    product: function () {
      const product = window.ud_product;
      return product;
    },

    // sanitizeTitle: function() {
    //   this.product._title = this.product.title.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
    // },

    productTags: function () {
      var tags = this.product.tags;
      var exclude_suffix = ["udfilter", "manual", "cad", "udsubtitle"];
      var new_tags = [];
      for (var i = 0; i < tags.length; i++) {
        var suffix = tags[i].split("_")[0];
        if (!exclude_suffix.includes(suffix)) {
          new_tags.push(tags[i]);
        }
      }
      return new_tags;
    },

    selectedVariant: function () {
      let variants = this.product.variants;
      let options = [];

      for (const [key, value] of Object.entries(this.options)) {
        options.push(value);
      }

      let variant = variants.find((variant) => {
        let variantOptions = variant.title.split(" / ");
        if (variantOptions.length == options.length && variantOptions.every((x) => options.includes(x))) {
          return variant;
        }
      });

      return variant;
    },

    // Cozy Earth Site Wide Discount
    sitewide_discount: function () {
      let discount = window.discount;
      let adjusted_discount = (100 - discount) / 100;
      return this.selectedVariant.price * adjusted_discount;
    },

    depth: function () {
      const depth = this.product.dimensions.depth
        ? this.product.dimensions.depth
        : this.product.globalMetafields["depth"];
      return depth;
    },

    width: function () {
      const width = this.product.dimensions.width
        ? this.product.dimensions.width
        : this.product.globalMetafields["width"];
      return width;
    },

    height: function () {
      const height = this.product.dimensions.height
        ? this.product.dimensions.height
        : this.product.globalMetafields["height"];
      return height;
    },

    technicalSpecificationImage: function () {
      return this.product.tech_spec_image;
    },

    technicalSpecifications: function () {
      const vm = this;
      var tech_specs = vm.product.globalMetafields["technical_specifications"];

      if (!tech_specs) return;

      // console.log("UD TECH SPECS: ", tech_specs);

      var html = '<article class="col col-12 col-lg-6"><section class="accordion" id="specAccordion0">';
      var chunks = tech_specs.split("<!SPLIT1!>");
      var words = tech_specs.split(/<!SPLIT2!>|<!SPLIT3!>|<!SPLIT1!>/);

      // console.log("# CHUNKS: ", chunks.length);

      // console.log("CHUNKS: ", chunks);

      var half = false;

      let accordion_counter = 0;

      // * Styling this html should be based off styles on pdp-tech-spec.liquid, this is fallback code
      for (var i = 0; i < chunks.length; i++) {
        if (chunks[i].length === 0) {
          continue;
        }
        //console.log("CHUNK: ", chunks[i])
        // * <!SPLIT3> Identifies Collapse content, so if it's falsey we create the Collapse Summary
        if (!chunks[i].includes("<!SPLIT3!>")) {
          //section header

          // if (words.indexOf(chunks[i]) > (words.length / 2) && half == false){
          //   half = true
          //   html += '</div><div class="col col-12 col-lg-6"><div class="header">' + chunks[i] + '</div>'
          // } else {
          //   html += '<div class="header">' + chunks[i] + '</div>'
          // }

          // * Find Halfway point and create a new column
          if (words.indexOf(chunks[i]) > words.length / 2 && half == false) {
            half = true;
            // close previous column
            html += `</section></article>`;
            // Start new column
            html += `<article class="col col-12 col-lg-6">
                <section 
                  class="accordion"
                  id="specAccordion1">`;

            accordion_counter++;
          }
          // Create Summary Buttons for Content
          html += `<summary
              class="accordion-item"
            >
              <h2
                class="accordion-header"
                id="heading${i}"
              >
                <button 
                  class="accordion-button ${i === 1 ? "" : "collapsed"}"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse${i}"
                  aria-expanded="true"
                  aria-controls="collapse${i}"
                >
                  <p
                    class="tw-w-full tw-block tw-pl-8 tw-text-black tw-font-helvetica-neue tw-text-lg tw-font-bold tw-leading-6 tw-text-left tw-uppercase lg:tw-pl-3"
                  > ${chunks[i]} 
                  </p>
                </button>
              </h2>
            </summary>`;
          // * Create Collapse Content
        } else {
          values = chunks[i].split("<!SPLIT3!>");
          //console.log("CHUNK VALUES: ", values)

          html += `<article 
              id="collapse${i - 1}"
              class="accordion-collapse collapse ${i === 2 ? "show" : ""}"
              aria-labelledby="heading${i - 1}"
            >
                <div
                  class="accordion-body"
                >`;

          for (var j = 0; j < values.length; j++) {
            if (values[j].length > 0 && values[j].includes("<!SPLIT2!>")) {
              // console.log(
              //   "UD LOG 1: " +
              //     '<div class="value"><span>' +
              //     values[j].split("<!SPLIT2!>")[0] +
              //     "</span><span>" +
              //     values[j].split("<!SPLIT2!>")[1] +
              //     "</span></div>"
              // );
              html += `<div class="value">
                  <span> ${values[j].split("<!SPLIT2!>")[0]} </span>
                    <span> ${values[j].split("<!SPLIT2!>")[1]} </span>
                </div>`;
            } else {
              // console.error("INVALID VALUES: ", values[j]);
            }
          }
          html += `</div></article>`;
        }
        // end chunk for loop
      }

      html += "</section></article>";
      return html;
    },

    specificationsUrl() {
      return (
        "https://blomberg.s3.amazonaws.com/specifications-library/" + this.product.variants[0].sku + "_spec-sheet.pdf"
      );
    },

    specSheetManuals() {
      let files = [];

      if (
        !this.product.files.spec_sheet_manuals.english &&
        !this.product.files.spec_sheet_manuals.spanish &&
        !this.product.files.spec_sheet_manuals.french
      )
        return files;

      if (this.product.files.spec_sheet_manuals.english !== "") {
        files.push({
          language: "English",
          src: `https:${this.product.files.spec_sheet_manuals.english}`,
        });
      }

      if (this.product.files.spec_sheet_manuals.spanish !== "") {
        files.push({
          language: "Spanish",
          src: `https:${this.product.files.spec_sheet_manuals.spanish}`,
        });
      }

      if (this.product.files.spec_sheet_manuals.french !== "") {
        files.push({
          language: "French",
          src: `https:${this.product.files.spec_sheet_manuals.french}`,
        });
      }

      return files;
    },

    userManuals: function () {
      let files = [];

      if (
        !this.product.files.user_manuals.english &&
        !this.product.files.user_manuals.spanish &&
        !this.product.files.user_manuals.french
      ) {
        if (!this.product.globalMetafields["downloads"]) return;

        let downloads = JSON.parse(this.product.globalMetafields["downloads"].replaceAll("'", '"'));
        let manuals = downloads.find((x) => x["name"] == "User Manuals");

        if (manuals) {
          let links = manuals.links;

          for (let i = 0; i < links.length; i++) {
            if (links[i].includes("en_US")) {
              files.push({
                language: "English",
                src: `https://blomberg.s3.amazonaws.com/user_manuals/${this.product.variants[0].sku}_English.pdf`,
              });
            } else if (links[i].includes("es_ES")) {
              files.push({
                language: "Spanish",
                src: `https://blomberg.s3.amazonaws.com/user_manuals/${this.product.variants[0].sku}_Spanish.pdf`,
              });
            } else if (links[i].includes("fr_FR")) {
              files.push({
                language: "French",
                src: `https://blomberg.s3.amazonaws.com/user_manuals/${this.product.variants[0].sku}_French.pdf`,
              });
            }
          }
        }

        return files;
      }

      if (this.product.files.user_manuals.english !== "") {
        files.push({
          language: "English",
          src: `https:${this.product.files.user_manuals.english}`,
        });
      }

      if (this.product.files.user_manuals.spanish !== "") {
        files.push({
          language: "Spanish",
          src: `https:${this.product.files.user_manuals.spanish}`,
        });
      }

      if (this.product.files.user_manuals.french !== "") {
        files.push({
          language: "French",
          src: `https:${this.product.files.user_manuals.french}`,
        });
      }

      return files;
    },

    energyAwardUrl: function () {
      return this.product.files.energy_award;
    },

    energyLabels: function () {
      let files = [];

      if (!this.product.files.energy_labels.united_states && !this.product.files.energy_labels.canada) return files;

      if (this.product.files.energy_labels.united_states !== "") {
        files.push({
          country: "USA",
          src: `https:${this.product.files.energy_labels.united_states}`,
        });
      }

      if (this.product.files.energy_labels.canada !== "") {
        files.push({
          country: "Canada",
          src: `https:${this.product.files.energy_labels.canada}`,
        });
      }

      return files;
    },

    installationManuals: function () {
      let files = [];

      if (this.product.files.installation_manuals.english !== "") {
        files.push({
          language: "English",
          src: `https:${this.product.files.installation_manuals.english}`,
        });
      }

      if (this.product.files.installation_manuals.spanish !== "") {
        files.push({
          language: "Spanish",
          src: `https:${this.product.files.installation_manuals.spanish}`,
        });
      }

      if (this.product.files.installation_manuals.french !== "") {
        files.push({
          language: "French",
          src: `https:${this.product.files.installation_manuals.french}`,
        });
      }

      return files;
    },

    cadFiles: function () {
      let files = [];

      if (!this.product.files.cad_files.length) {
        const tags = this.product.tags;
        let links = "";

        for (let i = 0; i < tags.length; i++) {
          const suffix = tags[i].split("_")[0];

          if (suffix == "cad") {
            let filetype = tags[i].split("_")[1];

            files.push({
              language: "English",
              filetype,
              src: `https://blomberg.s3.amazonaws.com/cad/${this.product.variants[0].sku}_${filetype}.zip`,
            });
          }
        }

        return files;
      } else {
        this.product.files.cad_files.forEach((file) => {
          files.push({
            filetype: file.split(".").pop().split("?")[0].toUpperCase(),
            src: file,
          });
        });
      }

      return files;
    },
  },

  watch: {
    selectedVariant: function () {
      if (this.carousel && this.selectedVariant.featured_media) {
        this.carousel.slideToLoop(this.product.media.map((x) => x.id).indexOf(this.selectedVariant.featured_media.id));
      }

      if (window.history.pushState) {
        let searchParams = new URLSearchParams(window.location.search);
        searchParams.set("variant", this.selectedVariant.id);
        let newPath = window.location.pathname + "?" + searchParams.toString() + window.location.hash;
        window.history.pushState(null, "", newPath);
      }
    },
  },

  methods: {
    updateQuantity(amount) {
      this.quantity = Math.min(this.selectedVariant.inventory_quantity, Math.max(1, this.quantity + amount));
    },

    formatMoney(value) {
      return Shopify.formatMoney(value);
    },

    addToCart() {
      udCart.addToCart(this.selectedVariant.id, this.product.globalMetafields.condition);
    },

    sendDataLayer(product, fileType, document) {
      // console.log("file tyle", fileType);
      // console.log("product", product.handle);
      window.dataLayer.push({
        event: "downloadFile",
        fileType: fileType,
        forProduct: product.handle,
        documentType: document,
      });
    },
  },

  created() {
    var vm = this;
    // console.log(this.product);

    this.product.options.forEach((option) => {
      this.options[option.name] = option.values[0];
    });

    // fetch(`/recommendations/products.json?product_id=${vm.product.id}&limit=${vm.limit}`)
    //   .then(
    //     function(response) {
    //       if (response.status !== 200) {
    //         console.log('Looks like there was a problem. Status Code: ' + response.status); return;
    //       } else {
    //         response.json().then(function(data) {
    //           console.log('data: ',data);
    //           vm.recommendedProducts = data.products
    //           console.log("recommended products: ", vm.recommendedProducts)
    //         });
    //       }
    //     }
    //   )
    //   .catch(function(err) {
    //     console.log('Fetch Error :-S', err);
    //   });
  },

  mounted() {
    // console.log("UD PRODUCT: ", this.product);

    this.carouselNav = new Swiper(this.$refs.carouselNav, {
      observer: true,
      observeSlideChildren: true,
      observeParents: true,
      spaceBetween: 10,
      slidesPerView: "auto",
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      direction: "vertical",
    });

    this.carousel = new Swiper(this.$refs.carousel, {
      loop: true,
      grabCursor: true,

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: this.carouselNav,
      },
      spaceBetween: 10,
      observer: true,
      observeSlideChildren: true,
      observeParents: true,
    });
  },
});

productController.component("pdp-tech-spec", window.pdpTechSpec);
productController.mount("#product");

function sendDataLayer(product, fileType, document) {
  // console.log("file tyle", fileType);
  // console.log("product", product.handle);
  window.dataLayer.push({
    event: "downloadFile",
    fileType: fileType,
    forProduct: product.handle,
    documentType: document,
  });
}
